import { createModel } from '@rematch/core'
import * as firebase from 'firebase'
// import { validate } from 'validate.js'
import { dispatch, store } from '../store'

interface ICheckoutItem {
  name: string
  amount: number
}

type DiscountType = 'none' | 'earlybird' | 'coupon'

interface IState {
  loading: boolean
  lectureId: string | null
  paymentType: PaymentType
  discountType: DiscountType
  invoiceType: string
  name: string
  email: string
  couponId: string
  couponDiscount: number
  mobileBarcode: string
  citizenDigiCert: string
  couponError?: Error
  checkoutItems: ICheckoutItem[]
  checkoutError?: Error
  orderErrors?: {
    [field: string]: string[];
  }
}

export default createModel({
  state: {
    loading: false,
    lectureId: null,
    paymentType: 'CREDIT',
    discountType: 'none',
    name: '',
    email: '',
    couponId: '',
    mobileBarcode: '',
    citizenDigiCert: '',
    invoiceType: '1',
    checkoutItems: [],
    couponDiscount: 0
  } as IState,
  reducers: {
    isLoading: (state: IState) => ({ ...state, loading: true }),
    isLoaded: (state: IState) => ({ ...state, loading: false }),
    resetError: (
      state: IState,
      type: 'checkoutError' | 'couponError' | 'orderErrors'
    ) => ({ ...state, [type]: undefined }),
    throwError: (
      state: IState,
      payload: {
        type: 'checkoutError' | 'couponError';
        error: Error;
      }
    ) => ({ ...state, [payload.type]: payload.error }),
    updateLectureId: (state: IState, lectureId) => ({ ...state, lectureId }),
    updateCheckoutItems: (state: IState, checkoutItems: ICheckoutItem[]) => ({
      ...state,
      checkoutItems
    }),
    updateCouponDiscount: (state: IState, couponDiscount: number) => ({
      ...state,
      couponDiscount
    }),
    // update type
    updatePaymentType: (state: IState, paymentType: string) => ({
      ...state,
      paymentType
    }),
    updateDiscountType: (state: IState, discountType: string) => ({
      ...state,
      discountType
    }),
    updateInvoiceType: (state: IState, invoiceType: string) => ({
      ...state,
      invoiceType
    }),
    // update input
    updateCoupon: (state: IState, couponId: string) => ({ ...state, couponId }),
    updateCitizenDigiCert: (state: IState, citizenDigiCert: string) => ({
      ...state,
      citizenDigiCert
    }),
    updateMobileBarcode: (state: IState, mobileBarcode: string) => ({
      ...state,
      mobileBarcode
    }),
    updateName: (state: IState, name: string) => ({ ...state, name }),
    updateEmail: (state: IState, email: string) => ({ ...state, email }),
    updateOrderErrors: (
      state: IState,
      orderErrors: { [field: string]: string[] }
    ) => ({ ...state, orderErrors })
  },
  effects: {
    async checkout() {
      const rootState = store.getState()
      const { lectureId, couponId, paymentType } = rootState.payment
      const getCheckoutItems = firebase
        .functions()
        .httpsCallable('payment-checkout')
      this.isLoading()
      this.resetError('checkoutError')
      getCheckoutItems({ lectureId, couponId, paymentType })
        .then(result => this.updateCheckoutItems(result.data))
        .then(this.isLoaded)
        .catch(error => this.throwError({ type: 'checkoutError', error }))
        .then(this.isLoaded)
    },
    async checkCoupon() {
      const rootState = store.getState()
      const couponId = rootState.payment.couponId
      const checkCoupon = firebase
        .functions()
        .httpsCallable('payment-checkCoupon')
      this.isLoading()
      this.resetError('couponError')
      checkCoupon({ couponId })
        .then(res => this.updateCouponDiscount(res.data))
        .then(dispatch.payment.checkout)
        .then(this.isLoaded)
        .catch(error => this.throwError({ type: 'couponError', error }))
        .then(this.isLoaded)
    },
    async createOrder() {
      const rootState = store.getState()
      const {
        lectureId,
        couponId,
        paymentType,
        name,
        email,
        invoiceType,
        citizenDigiCert,
        mobileBarcode
      } = rootState.payment
      this.resetError('orderErrors')
      // validate
      // const constraints = {
      //   name: {
      //     presence: {
      //       message: '請填寫姓名'
      //     }
      //   },
      //   email: {
      //     presence: {
      //       message: '請填寫電子信箱'
      //     },
      //     email: {
      //       message: '電子信箱格式錯誤'
      //     }
      //   }
      // }
      // const orderErrors = validate({ name, email }, constraints)
      // if (orderErrors) {
      //   dispatch.payment.updateOrderErrors(orderErrors)
      //   return
      // }
      // create Spgateway payment
      const createSpgatewayPayment = firebase
        .functions()
        .httpsCallable('payment-createSpgatewayPayment')
      // create order
      // const createOrder = firebase
      //   .functions()
      //   .httpsCallable('payment-createOrder')
      const invoiceParams = {
        CustomerIdentifier: '',
        CustomerName: name,
        CustomerAddr: '',
        CustomerPhone: '',
        CustomerEmail: email,
        CarruerType: invoiceType,
        CarruerNum:
          invoiceType === '2'
            ? citizenDigiCert
            : invoiceType === '3'
            ? mobileBarcode
            : '',
        Donation: '2',
        LoveCode: '',
        Print: '0'
      }
      this.isLoading()
      createSpgatewayPayment({
        lectureId,
        couponId: couponId ? couponId : null,
        paymentType,
        invoiceParams,
        callbackURL: window.location.href
      })
        .then(result => {
          const htmlStr = result.data
          document.write(htmlStr)
        })
        .then(this.isLoaded)
        .catch(error => this.throwError({ type: 'orderError', error }))
        .then(this.isLoaded)
    }
  },
  selectors: {}
})



// WEBPACK FOOTER //
// ./src/models/payment.ts